export enum BADGE_TYPES {
  BADGE = "BADGE",
  BADGE_PLUS = "BADGE_PLUS",
  REMOTE_CONTROLLER = "REMOTE_CONTROLLER",
  REMOTE_CONTROLLER_PLUS = "REMOTE_CONTROLLER_PLUS",
}

export enum BADGE_PROVIDERS {
  URMET = "URMET",
}

export enum ORDER_TYPES {
  REPLACEMENT = "REPLACEMENT",
  CREATION = "CREATION",
}
